import { useNavigate } from 'react-router-dom';
import BackgroundImage from '../../../assets/BackgroundImage.png';
import AdminNav from './AdminNav';

const Hero = () => {
    const navigate = useNavigate();

    return (
        <div className="w-full bg-cover bg-left-top md:bg-right 2xl:bg-right-bottom h-fit min-h-screen flex flex-col justify-center 1.5xl:px-[104px]" style={{ backgroundImage: `url(${BackgroundImage})` }}>

            <div className="fixed top-0 left-0 right-0 z-50">
                <AdminNav />
            </div>

            <div className="w-fit h-full flex flex-col justify-center px-basePx xs:px-xsPx 1.5xl:px-0">
                <h1 className="w-full md:w-[40rem] lg:w-[48rem] 1.5xl:w-[45rem] 2.5xl:w-[80rem] mb-0 text-left text-white text-[44px] sm:text-[45px] lg:text-[60px] 1.5xl:text-[80px] 2.5xl:text-[116px] font-allroundgothic font-[600]">CharmHealthHub Admin Portal</h1>


                <div className="w-full mt-10 md:w-[40rem] lg:w-[52rem] 2xl:w-[58rem] flex justify-center">
                    <button className="w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                        onClick={() => navigate('/admins/login')}
                    >Login </button>
                </div>
            </div>
        </div>


    );
}

export default Hero;